// World-frame axis gizmo: red +X, green +Y, blue +Z lines from origin.
// See ticket 891.

import * as THREE from 'three';
import { WebGLElement } from './base.js';

export class ThreeWorldAxes extends WebGLElement {
  static properties = {
    ...WebGLElement.properties,
    length: { type: Number },
  };

  constructor() {
    super();
    this.length = 1;
  }

  createObject3D() {
    const axes = new THREE.AxesHelper(this.length);
    axes.material.transparent = true;
    axes.material.opacity = 0.9;
    return axes;
  }

  updated(changed) {
    super.updated(changed);
    if (!this.object3D) return;
    if (changed.has('length')) {
      const parent = this.object3D.parent;
      if (parent) parent.remove(this.object3D);
      this.object3D.geometry?.dispose();
      this.object3D.material?.dispose();
      const next = new THREE.AxesHelper(this.length);
      next.material.transparent = true;
      next.material.opacity = 0.9;
      this.object3D = next;
      if (parent) parent.add(next);
    }
  }
}

customElements.define('three-world-axes', ThreeWorldAxes);
